export type DocumentFormat = 'hwpx' | 'hwp5' | 'unknown';

/** 바이트 데이터의 magic bytes로 문서 포맷 감지 */
export function detectFormat(data: Uint8Array): DocumentFormat {
  if (data.length < 4) return 'unknown';

  // ZIP (PK\x03\x04) → HWPX
  if (data[0] === 0x50 && data[1] === 0x4b && data[2] === 0x03 && data[3] === 0x04) {
    return 'hwpx';
  }

  // OLE Compound File (D0 CF 11 E0) → HWP5
  if (data[0] === 0xd0 && data[1] === 0xcf && data[2] === 0x11 && data[3] === 0xe0) {
    return 'hwp5';
  }

  return 'unknown';
}
